<template>
  <div class="small-collapse" id="Step2" v-if="product">
    <!-- Make a gift -->
    <div class="wwf-checkbox" v-if="product.producttype == 'adoption'">
      <label>
        Make this a gift for someone
        <input
          type="checkbox"
          id="isGift-step-2"
          name="isGift"
          v-model="donation.isGift"
        >
        <span class="checkbox"></span>
      </label>
    </div>
    <!-- /Make a gift -->

    <!-- Wildcard-->
    <div class="small-collapse small-12 columns" v-if="product.producttype == 'wildcard'">
      <h2>Who is this for?</h2>
      <div class="small-12 columns">
        <div class="wilcards--selected">
          <img
            :src="product.packages.find(x=>x.code == donation.packagecode) ? product.packages.find(x=>x.code == donation.packagecode).img : null"
            class="tooltipstered"
          >
        </div>
      </div>
      <div class="small-12 columns">
        <div class="field" :class="donation.wildcard.dear ? 'has-content' : ''">
          <input
            name="dear"
            type="text"
            v-model="donation.wildcard.dear"
            v-validate="'required'"
            :class="{'border-red': errors.has('dear')}"
            placeholder="Enter the name"
          >
          <label for="dear">Dear {{ errors.first('dear') ? 'required' : '' }}</label>
        </div>
      </div>
      <div class="small-12 columns">
        <div class="field" :class="donation.wildcard.message ? 'has-content' : ''">
          <textarea
            name="message"
            type="text"
            v-model="donation.wildcard.message"
            v-validate="'required'"
            :class="{'border-red': errors.has('message')}"
            placeholder="Enter the message"
          ></textarea>
          <label for="message">Your personal message {{ errors.first('message') ? 'required' : '' }}</label>
        </div>
      </div>
      <div class="small-12 columns">
        <div class="field" :class="donation.wildcard.email ? 'has-content' : ''">
          <input
            type="email"
            name="recepientsemail"
            id="recepientsemail"
            v-model="donation.wildcard.email"
            v-validate="'required|email'"
            :class="{'border-red': errors.has('recepientsemail')}"
            placeholder="Email"
          >
          <label
            for="recepientsemail"
          >Recipients email {{ errors.firstByRule('recepientsemail', 'required') ? 'required' : '' }} {{ errors.firstByRule('recepientsemail', 'email') ? 'invalid' : '' }}</label>
        </div>
      </div>

      <div class="small-12 columns">
        <h2>When do you want it sent?</h2>
        <!-- DESKTOP-->
        <div class="field" :class="donation.wildcard.scheduledate ? 'has-content' : ''">
          <datepicker
            :disabledDates="disabledFn"
            name="scheduledate"
            v-validate="'required'"
            :minimumView="'day'"
            :format="'dd/MM/yyyy'"
            :input-class="{'border-red': errors.has('scheduledate')}"
            v-model="donation.wildcard.scheduledate"
            :maximumView="'month'"
            :initialView="'day'"
            placeholder="Enter your date"
          ></datepicker>
          <label for="scheduledate">
            Choose a date {{ errors.first('scheduledate') ? 'required' : '' }}
            <i
              class="far fa-calendar-alt"
            ></i>
          </label>
        </div>
      </div>
    </div>
    <!-- /Wildcard -->
    <div class="small-12 columns">
      <h2>Enter your details</h2>
    </div>
    <div class="wwf-checkbox">
      <label>
        This donation is on behalf of a business
        <input
          type="checkbox"
          id="isBehalfBusiness"
          name="isBehalfBusiness"
          v-model="donation.isBehalfBusiness"
        >
        <span class="checkbox"></span>
      </label>
    </div>

    <div
      class="small-collapse small-12 columns field-businessname"
      v-if="donation.isBehalfBusiness"
    >
      <div class="small-12 columns">
        <div class="field" :class="donation.bussiness.name ? 'has-content' : ''">
          <input
            name="businessName"
            type="text"
            v-model="donation.bussiness.name"
            v-validate="'required'"
            :class="{'border-red': errors.has('businessName')}"
            placeholder="Enter your business name"
            autocomplete="organization"
          >
          <label
            for="businessName"
          >Business name {{ errors.first('businessName') ? 'required' : '' }}</label>
        </div>
      </div>
    </div>

    <div class="row">
      <!-- TITLE -->
      <div class="small-6 medium-3 columns left-field field-title">
        <div class="field" :class="donation.title ? 'has-content' : ''">
          <select
            name="title"
            v-model="donation.title"
            v-validate="'required'"
            :class="{'border-red': errors.has('title')}"
            placeholder="Title"
            autocomplete="honorific-prefix"
          >
            <option value disabled selected>Select a title</option>
            <option value="Dr">Dr</option>
            <option value="Miss">Miss</option>
            <option value="Mr">Mr</option>
            <option value="Mrs">Mrs</option>
            <option value="Ms">Ms</option>
            <option value="Mx">Mx</option>
          </select>
          <label for="title">Title</label>
        </div>
      </div>
      <div class="title-required">{{ errors.first('title') ? 'Title required' : '' }}</div>
    </div>

    <div class="row">
      <!-- FIRST NAME -->
      <div class="small-12 medium-6 columns left-field field-firstname">
        <div class="field" :class="donation.firstname ? 'has-content' : ''">
          <input
            name="firstname"
            type="text"
            v-model="donation.firstname"
            v-validate="'required'"
            :class="{'border-red': errors.has('firstname')}"
            placeholder="Enter your first name"
            autocomplete="given-name"
          >
          <label for="firstname">First name {{ errors.first('firstname') ? 'required' : '' }}</label>
        </div>
      </div>

      <!-- LAST NAME -->
      <div class="small-12 medium-6 right-field columns field-lastname">
        <div class="field" :class="donation.lastname ? 'has-content' : ''">
          <input
            name="lastname"
            type="text"
            v-model="donation.lastname"
            v-validate="'required'"
            :class="{'border-red': errors.has('lastname')}"
            placeholder="Enter your last name"
            autocomplete="family-name"
          >
          <label for="lastname">Last name {{ errors.first('lastname') ? 'required' : '' }}</label>
        </div>
      </div>
    </div>

    <div class="row">
      <!-- COUNTRY -->
      <div class="small-6 medium-6 left-field columns">
        <div class="field" :class="donation.billing.country ? 'has-content' : ''">
          <select
            name="country"
            v-model="donation.billing.country"
            v-validate="'required'"
            :class="{'border-red': errors.has('country')}"
            autocomplete="country"
            @change="countryChanged"
          >
            <option
              v-for="(countries, index) in countriesList"
              :value="countries.name"
            >{{countries.name}}</option>
          </select>

          <label for="country">Country {{ errors.first('country') ? 'required' : '' }}</label>
        </div>
      </div>
      <div
        class="small-12 columns alert"
        v-show="donation.billing.country != 'Australia' && product.producttype == 'adoption'"
      >
        <p>We're sorry, gifts and toy products can only be delivered within Australia.</p>
      </div>
    </div>

    <div class="row">
      <div
        class="small-12 columns field-address"
        v-if="!showFullAddress && !disabledGoogleAutocomplete && showAddressSuggestions"
      >
        <div class="field has-content">
          <form autocomplete="off" onkeydown="return event.key != 'Enter';">
            <sensis-autocomplete
              :id="dynamicId"
              class="form-control"
              :classname="errors.has(dynamicId) ? 'border-red' : ''"
              @addressSelected="sensisSelectedAddress"
            ></sensis-autocomplete>
          </form>
          <label :for="dynamicId">Enter your address</label>
          <span class="wwf-alert-address">
            <p v-if="errors.first(dynamicId)">
              We cannot find your address.
              <a
                v-on:click="showFullAddress = true"
              >Please click here to enter your address manually.</a>
            </p>
            <a
              v-if="!errors.first(dynamicId)"
              v-on:click="showFullAddress = true"
            >If you don't find your address or don't live in Australia, please click here to enter your address manually.</a>
          </span>
        </div>
      </div>
    </div>

    <div class="row">
      <div
        class="small-12 columns small-collapse"
        v-if="showFullAddress || disabledGoogleAutocomplete"
      >
        <div class="small-12 columns field-address-readonly" v-if="addressSelected">
          <div class="field has-content">
            <input name="addressSelected" type="text" v-model="addressSelected" readonly>
            <label :for="dynamicId">Your address</label>
          </div>
        </div>
        <div class="small-12 columns" v-if="!addressSelected">
          <h2>Enter your address</h2>
        </div>
        <div class="small-6 columns left-field">
          <div
            class="field"
            :class="donation.billing.unitnumber ? 'has-content' : 'unit-no-border'"
          >
            <input
              name="unitnumber"
              type="tel"
              v-model="donation.billing.unitnumber"
              :class="{'border-red': errors.has('unitnumber')}"
              placeholder="Unit #"
            >
            <label for="unitnumber">Unit number</label>
          </div>
        </div>
        <div class="small-6 columns right-field unit-no-alert-container">
          <div>
            <div class="unit-no-alert" :class="donation.billing.unitnumber ? 'fadeaway' : ''">
              <p>Please enter unit number if applicable</p>
            </div>
          </div>
        </div>
        <div class="small-6 columns left-field">
          <div class="field" :class="donation.billing.streetno ? 'has-content' : ''">
            <input
              name="streetno"
              type="text"
              v-model="donation.billing.streetno"
              v-validate="'required'"
              :class="{'border-red': errors.has('streetno')}"
              placeholder="Street #"
              autocomplete="no"
            >
            <label for="streetno">Street number {{ errors.first('streetno') ? 'required' : '' }}</label>
          </div>
        </div>
        <div class="small-6 columns right-field">
          <div class="field" :class="donation.billing.streetname ? 'has-content' : ''">
            <input
              name="streetname"
              type="text"
              v-model="donation.billing.streetname"
              v-validate="'required'"
              :class="{'border-red': errors.has('streetname')}"
              placeholder="Street Name"
              autocomplete="address-line1"
            >
            <label for="streetname">Street name {{ errors.first('streetname') ? 'required' : '' }}</label>
          </div>
        </div>
        <div class="small-6 columns left-field">
          <div class="field" :class="donation.billing.postcode ? 'has-content' : ''">
            <input
              v-if="donation.billing.country == 'Australia'"
              name="postcode"
              type="tel"
              v-model="donation.billing.postcode"
              v-validate="'required'"
              :class="{'border-red': errors.has('postcode')}"
              placeholder="Postcode"
              maxlength="4"
              autocomplete="postal-code"
            >
            <input
              v-if="donation.billing.country != 'Australia'"
              name="postcode"
              type="tel"
              v-model="donation.billing.postcode"
              v-validate="'required'"
              :class="{'border-red': errors.has('postcode')}"
              placeholder="Postcode"
              autocomplete="postal-code"
            >

            <label for="postcode">Postcode {{ errors.first('postcode') ? 'required' : '' }}</label>
          </div>
        </div>
        <div class="small-6 columns right-field">
          <div class="field" :class="donation.billing.state ? 'has-content' : ''">
            <select
              v-if="donation.billing.country == 'Australia'"
              name="state"
              v-model="donation.billing.state"
              v-validate="'required'"
              :class="{'border-red': errors.has('state')}"
            >
              <option value disabled selected>Select a state</option>
              <option value="NSW">NSW</option>
              <option value="ACT">ACT</option>
              <option value="NT">NT</option>
              <option value="SA">SA</option>
              <option value="WA">WA</option>
              <option value="VIC">VIC</option>
              <option value="QLD">QLD</option>
              <option value="TAS">TAS</option>
            </select>
            <input
              v-if="donation.billing.country != 'Australia'"
              name="state"
              type="text"
              v-model="donation.billing.state"
              :class="{'border-red': errors.has('state')}"
              placeholder="State"
            >
            <label for="state">State {{ errors.first('state') ? 'required' : '' }}</label>
          </div>
        </div>
        <div class="small-6 columns left-field">
          <div class="field" :class="donation.billing.suburb ? 'has-content' : ''">
            <input
              name="suburb"
              type="text"
              v-model="donation.billing.suburb"
              v-validate="'required'"
              :class="{'border-red': errors.has('suburb')}"
              placeholder="Suburb"
            >
            <label for="suburb">Suburb {{ errors.first('suburb') ? 'required' : '' }}</label>
          </div>
        </div>
        <div class="small-12 medium-6 columns right-field field-phone">
          <div class="field" :class="donation.phone ? 'has-content' : ''">
            <input
              name="phone"
              type="tel"
              v-model="donation.phone"
              min="8"
              max="12"
              v-validate="{ required: true, checkPhoneNumber: true }"
              :class="{'border-red': errors.has('phone') || errors.has('checkPhoneNumber') }"
              placeholder="Enter your phone"
              autocomplete="tel"
            >
            <div class="input-loading" v-if="checkPhoneLoading">
              <img src="https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/2974/dist/assets/img/loading-tail-spin.svg">
            </div>
            <label for="phone">Phone</label>

            <span class="wwf-alert">
              <p v-if="errors.has('phone')">{{errors.first('phone')}}</p>
            </span>
          </div>
        </div>
      </div>
    </div>

    <div v-if="bequestCheckbox" checked="checked" class="wwf-checkbox bequest-checkbox">
      <label>
        Please send me information about including wildlife and WWF in my Will.
        <input
          type="checkbox"
          id="opt-in-step-2"
          name="opt-in"
          v-model="donation.bequest"
        >
        <span class="checkbox"></span>
      </label>
    </div>

    <div v-if="donation.isGift">
      <div class="small-collapse">
        <div class="small-12 columns">
          <h2>Enter recipients details</h2>
        </div>
        <div class="row">
          <!-- TITLE -->
          <div class="small-6 medium-3 columns left-field">
            <div class="field" :class="donation.gift.title ? 'has-content' : ''">
              <select
                name="gift-title"
                v-model="donation.gift.title"
                v-validate="'required'"
                :class="{'border-red': errors.has('gift-title')}"
                placeholder="Title"
              >
                <option value disabled selected>Select a title</option>
                <option value="Mr">Mr</option>
                <option value="Mrs">Mrs</option>
                <option value="Ms">Ms</option>
                <option value="Miss">Miss</option>
              </select>
              <label for="gift-title">Title</label>
            </div>
          </div>
          <div
            class="title-required title-required-gift"
          >{{ errors.first('gift-title') ? 'Title required' : '' }}</div>
        </div>

        <div class="row">
          <!-- FIRST NAME -->
          <div class="small-12 medium-6 columns left-field">
            <div class="field" :class="donation.gift.firstname ? 'has-content' : ''">
              <input
                name="gift-firstname"
                type="text"
                v-model="donation.gift.firstname"
                v-validate="'required'"
                :class="{'border-red': errors.has('gift-firstname')}"
                placeholder="Enter the first name"
              >
              <label
                for="gift-firstname"
              >First name {{ errors.first('gift-firstname') ? 'required' : '' }}</label>
            </div>
          </div>

          <!-- LAST NAME -->
          <div class="small-12 medium-6 columns right-field">
            <div class="field" :class="donation.gift.lastname ? 'has-content' : ''">
              <input
                name="gift-lastname"
                type="text"
                v-model="donation.gift.lastname"
                v-validate="'required'"
                :class="{'border-red': errors.has('gift-lastname')}"
                placeholder="Enter your last name"
              >
              <label
                for="gift-lastname"
              >Last name {{ errors.first('gift-lastname') ? 'required' : '' }}</label>
            </div>
          </div>
        </div>
      </div>

      <div class="wwf-checkbox">
        <label>
          This gift is to be delivered to the same billing address
          <input
            type="checkbox"
            name="isSameAddress"
            v-model="donation.isSameAddress"
          >
          <span class="checkbox"></span>
        </label>
      </div>

      <div class="small-collapse" v-if="!donation.isSameAddress">
        <div
          class="small-12 columns"
          v-if="!showFullAddressGifts && !disabledGoogleAutocomplete && showAddressGiftSuggestions"
        >
          <div class="field has-content">
            <form autocomplete="off" onkeydown="return event.key != 'Enter';">
              <sensis-autocomplete
                id="gift-map"
                class="form-control"
                :classname="errors.has('gift-map') ? 'border-red' : ''"
                @addressSelected="sensisSelectedAddressGift"
              ></sensis-autocomplete>
            </form>
            <label for="gift-map">Enter the address</label>
            <span class="wwf-alert-address">
              <p v-if="errors.first('gift-map')">
                We cannot find the address.
                <a
                  v-on:click="showFullAddressGifts = true"
                >Please click here to enter your address manually.</a>
              </p>
              <a
                v-if="!errors.first('gift-map')"
                class="wwf-alert-address-href"
                v-on:click="showFullAddressGifts = true"
              >If you don't find your address or don't live in Australia, please click here to enter your address manually.</a>
            </span>
          </div>
        </div>

        <div class="row small-collapse" v-if="showFullAddressGifts || disabledGoogleAutocomplete">
          <div class="small-12 columns field-address-readonly" v-if="addressgiftSelected">
            <div class="field has-content">
              <input name="addressgiftSelected" type="text" v-model="addressgiftSelected" readonly>
              <label :for="addressgiftSelected">The recipients address</label>
            </div>
          </div>
          <div class="small-12 columns" v-if="!addressgiftSelected">
            <h2>Enter recipients address</h2>
          </div>

          <div class="small-6 columns left-field">
            <div class="field" :class="donation.gift.unitnumber ? 'has-content' : ''">
              <input
                name="gift-unitnumber"
                type="tel"
                v-model="donation.gift.unitnumber"
                :class="{'border-red': errors.has('gift-unitnumber')}"
                placeholder="Unit #"
              >
              <label for="gift-unitnumber">Unit number</label>
            </div>
          </div>
          <div class="small-6 columns right-field">
            <div class="field" :class="donation.gift.streetno ? 'has-content' : ''">
              <input
                name="gift-streetno"
                type="text"
                v-model="donation.gift.streetno"
                v-validate="'required'"
                :class="{'border-red': errors.has('gift-streetno')}"
                placeholder="Street #"
                autocomplete="no"
              >
              <label
                for="gift-streetno"
              >Street number {{ errors.first('gift-streetno') ? 'required' : '' }}</label>
            </div>
          </div>
          <div class="small-6 columns left-field">
            <div class="field" :class="donation.gift.streetname ? 'has-content' : ''">
              <input
                name="gift-streetname"
                type="text"
                v-model="donation.gift.streetname"
                v-validate="'required'"
                :class="{'border-red': errors.has('gift-streetname')}"
                placeholder="Street Name"
              >
              <label
                for="gift-streetname"
              >Street name {{ errors.first('gift-streetname') ? 'required' : '' }}</label>
            </div>
          </div>
          <div class="small-6 columns right-field">
            <div class="field" :class="donation.gift.postcode ? 'has-content' : ''">
              <input
                v-if="donation.gift.country == 'Australia'"
                name="gift-postcode"
                type="tel"
                v-model="donation.gift.postcode"
                v-validate="'required'"
                maxlength="4"
                :class="{'border-red': errors.has('gift-postcode')}"
                placeholder="Postcode"
              >
              <input
                v-if="donation.gift.country != 'Australia'"
                name="gift-postcode"
                type="text"
                v-model="donation.gift.postcode"
                v-validate="'required'"
                :class="{'border-red': errors.has('gift-postcode')}"
                placeholder="Postcode"
              >

              <label
                for="gift-postcode"
              >Postcode {{ errors.first('gift-postcode') ? 'required' : '' }}</label>
            </div>
          </div>
          <div class="small-6 columns left-field">
            <div class="field" :class="donation.gift.state ? 'has-content' : ''">
              <select
                v-if="donation.gift.country == 'Australia'"
                name="gift-state"
                v-model="donation.gift.state"
                v-validate="'required'"
                :class="{'border-red': errors.has('gift-state')}"
              >
                <option value disabled selected>Select a state</option>
                <option value="NSW">NSW</option>
                <option value="ACT">ACT</option>
                <option value="NT">NT</option>
                <option value="SA">SA</option>
                <option value="WA">WA</option>
                <option value="VIC">VIC</option>
                <option value="QLD">QLD</option>
                <option value="TAS">TAS</option>
              </select>
              <input
                v-if="donation.gift.country != 'Australia'"
                name="gift-state"
                type="text"
                v-model="donation.gift.state"
                :class="{'border-red': errors.has('gift-state')}"
                placeholder="State"
              >
              <label for="gift-state">State {{ errors.first('gift-state') ? 'required' : '' }}</label>
            </div>
          </div>
          <div class="small-6 columns right-field">
            <div class="field" :class="donation.gift.suburb ? 'has-content' : ''">
              <input
                name="gift-suburb"
                type="text"
                v-model="donation.gift.suburb"
                v-validate="'required'"
                :class="{'border-red': errors.has('gift-suburb')}"
                placeholder="Suburb"
              >
              <label for="gift-suburb">Suburb {{ errors.first('gift-suburb') ? 'required' : '' }}</label>
            </div>
          </div>
          <div class="small-6 columns left-field end">
            <div class="field" :class="donation.gift.country ? 'has-content' : ''">
              <select
                name="gift-country"
                v-model="donation.gift.country"
                v-validate="'required'"
                :class="{'border-red': errors.has('gift-country')}"
              >
                <option
                  v-for="(countries, index) in countriesList"
                  :value="countries.name"
                >{{countries.name}}</option>
              </select>

              <label for="gift-country">Country {{ errors.first('gift-country') ? 'required' : '' }}</label>
            </div>
          </div>
          <div
            class="small-12 columns alert"
            v-show="donation.gift.country != 'Australia' && product.producttype == 'adoption'"
          >
            <p>We're sorry, gifts and toy products can only be delivered within Australia.</p>
          </div>
        </div>
      </div>
    </div>

    <div class="small-12 columns payment-type">
      <h2>Choose payment type</h2>
      <ul class="wwf-radio-bttns payment-type--radio">
        <li>
          <label>
            <span class="cc-title">Credit card</span>
            <img src="https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/2974/dist/assets/img/cards/cc-visa.svg" class="paymentType paymentType--visa">
            <img src="https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/2974/dist/assets/img/cards/cc-mastercard.svg" class="paymentType paymentType--mc">
            <img src="https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/2974/dist/assets/img/cards/cc-amex-alt.svg" class="paymentType paymentType--amex">
            <input
              type="radio"
              v-model="payementType"
              name="paymentType"
              value="wwf_purchasetokenise"
              id="payementTypeCC"
              v-validate="'required'"
              data-vv-as="payment type"
              @change="donation.payementType = null"
            >
            <span class="wwf-radio"></span>
          </label>
        </li>
        <li v-if="product.producttype != 'wildcard'">
          <label>
            <span class="cc-title">Direct debit</span>
            <input
              type="radio"
              v-model="payementType"
              name="paymentType"
              value="wwf_directdebit"
              id="payementTypeDD"
              v-validate="'required'"
              data-vv-as="payment type"
              @change="donation.payementType = null"
            >
            <span class="wwf-radio"></span>
          </label>
        </li>
        <li v-if="donation.type == 'Single'">
          <label>
            <span class="cc-title">PayPal</span>
            <img src="https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/2974/dist/assets/img/cards/PayPal.png" class="paymentType paymentType--PayPal">
            <input
              type="radio"
              v-model="payementType"
              name="paymentType"
              value="wwf_paypal"
              id="payementTypePP"
              v-validate="'required'"
              data-vv-as="payment type"
              @change="donation.payementType = payementType"
            >
            <span class="wwf-radio"></span>
          </label>
        </li>
        <span class="wwf-alert">
          <p v-if="errors.first('paymentType')">{{errors.first('paymentType')}}</p>
        </span>
      </ul>
    </div>
  </div>
</template>

<script>
import { Validator } from "vee-validate";
import SensisAutocomplete from "./../SensisAutocomplete";
import Datepicker from "vuejs-datepicker";
import moment from "moment";
import {
  getNameByDonationType,
  getCountriesList
} from "../../helpers";
import gtm from "../../utils/gtm";

import { mapState } from "vuex";

export default {
  components: { SensisAutocomplete, Datepicker },
  data() {
    return {
      timeout: null,
      lastTimestamp: Date.now(),
      checkPhoneLoading: false,
      countriesList: getCountriesList(),
      payementType: "wwf_purchasetokenise",
      disabledFn: {
        customPredictor: (date) => {
          if (this.isEarthHour && (moment(new Date()).isAfter(date, "day") || moment(date).isAfter(moment('28-03-2021', 'DD-MM-YYYY'), "day"))) {
            return true;
          } else if (moment(new Date()).isAfter(date, "day")) {
            return true;
          }
        }
      },
      bequestCheckbox: true
    };
  },
  computed: {
    ...mapState({
      donation: state => state.donation.donation,
      product: state => state.product.product,
      packages: state => state.product.packagesProduct
    }),
    addressSelected: {
      get() {
        return this.$store.getters.step2Data.addressSelected;
      },
      set(value) {
        this.$store.commit("updateStep2Data", {
          field: "addressSelected",
          value
        });
      }
    },
    addressgiftSelected: {
      get() {
        return this.$store.getters.step2Data.addressgiftSelected;
      },
      set(value) {
        this.$store.commit("updateStep2Data", {
          field: "addressgiftSelected",
          value
        });
      }
    },
    showAddressSuggestions: {
      get() {
        return this.$store.getters.step2Data.showAddressSuggestions;
      },
      set(value) {
        this.$store.commit("updateStep2Data", {
          field: "showAddressSuggestions",
          value
        });
      }
    },
    showAddressGiftSuggestions: {
      get() {
        return this.$store.getters.step2Data.showAddressGiftSuggestions;
      },
      set(value) {
        this.$store.commit("updateStep2Data", {
          field: "showAddressGiftSuggestions",
          value
        });
      }
    },
    showFullAddress: {
      get() {
        return this.$store.getters.step2Data.showFullAddress;
      },
      set(value) {
        this.$store.commit("updateStep2Data", {
          field: "showFullAddress",
          value
        });
      }
    },
    showFullAddressGifts: {
      get() {
        return this.$store.getters.step2Data.showFullAddressGifts;
      },
      set(value) {
        this.$store.commit("updateStep2Data", {
          field: "showFullAddressGifts",
          value
        });
      }
    }
  },
  beforeMount() {
    this.dynamicId = "shh-" + Date.now().toString();
  },
  created() {
    const urlParams = new URLSearchParams(window.location.search);
    const param = urlParams.get("legacy");
    this.bequestCheckbox = param && param === 'false' ? false : true;

    const checkPhoneNumber = phone => {
      // Only check for australian numbers
      if (this.donation.billing.country !== "Australia") {
        return { valid: true };
      } else if (phone.length > 0) {
        return new Promise((resolve, reject) => {
          let timestamp = Date.now(); // timestamp for this api call
          this.lastTimestamp = timestamp; // 1 , 2 , 3
          this.checkPhoneLoading = true;
          // Fetch Suggestions
          this.$store
            .dispatch("validatePhone", phone)
            .then(response => {
              if (response && timestamp >= this.lastTimestamp) {
                this.checkPhoneLoading = false;
                resolve(response);
              }
            })
            .catch(err => {
              console.error(err);
              this.checkPhoneLoading = false;
              // If the call failed, do not keep the user from donating
              resolve({
                valid: true
              });
            });
        });
      } else {
        return {
          valid: false,
          data: { message: "Invalid phone number, try again" }
        };
      }
    };

    Validator.extend("checkPhoneNumber", {
      validate: checkPhoneNumber,
      getMessage: (field, params, data) => data.message
    });
  },
  props: {
    disabledGoogleAutocomplete: {
      // Attribute for the version of the product
      type: Boolean,
      default: false
    },
    thankYouUrl: {
      // Attribute for the version of the product
      type: String,
      default: null
    },
    useNewCheckout: {
      type: Boolean,
      default: false
    },
    isEarthHour: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    getAddressData: function(addressData, placeResultData, id) {
      this.donation.billing.unitnumber = addressData.subpremise || null;
      this.donation.billing.streetno = addressData.street_number;
      this.donation.billing.streetname = addressData.route;
      this.donation.billing.postcode = addressData.postal_code;
      this.donation.billing.state = addressData.administrative_area_level_1;
      this.donation.billing.suburb = addressData.locality;
      this.donation.billing.country = addressData.country;
      this.addressSelected = placeResultData.formatted_address || null;
      this.showFullAddress = true;
    },
    getAddressDataGift: function(addressData, placeResultData, id) {
      this.donation.gift.unitnumber = addressData.subpremise || null;
      this.donation.gift.streetno = addressData.street_number;
      this.donation.gift.streetname = addressData.route;
      this.donation.gift.postcode = addressData.postal_code;
      this.donation.gift.state = addressData.administrative_area_level_1;
      this.donation.gift.suburb = addressData.locality;
      this.donation.gift.country = addressData.country;
      this.addressgiftSelected = placeResultData.formatted_address || null;
      this.showFullAddressGifts = true;
    },
    countryChanged() {
      // Sensis Austocomplete is only available for Australia
      if (this.donation.billing.country === "Australia") {
        this.showAddressSuggestions = true;
        this.showAddressGiftSuggestions = true;
        if (!this.addressSelected) {
          this.showFullAddress = false;
        }
        if (!this.addressgiftSelected) {
          this.showFullAddressGifts = false;
        }
      } else {
        this.showFullAddress = true;
        this.showFullAddressGifts = true;
        this.showAddressSuggestions = false;
        this.showAddressGiftSuggestions = false;
      }
    },
    sensisSelectedAddress(address, formattedAddress) {
      this.addressSelected = formattedAddress;
      this.donation.billing = address;
      this.showFullAddress = true;
    },
    sensisSelectedAddressGift(address, formattedAddress) {
      this.addressgiftSelected = formattedAddress;
      // Merge to two object, not override
      this.donation.gift = { ...this.donation.gift, ...address };
      this.showFullAddressGifts = true;
    },
    validate() {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll().then(result => {
          if (!result) {
            reject("The form on step2 product is invalid");
          } else {
            console.log("Validate - showFullAddress", this.showFullAddress);
            let hasErrors = false;
            if (!this.showFullAddress && !this.disabledGoogleAutocomplete) {
              this.errors.add({
                field: this.dynamicId,
                msg: "Address required"
              });
              hasErrors = true;
            }

            if (
              this.donation.isGift &&
              !this.showFullAddressGifts &&
              !this.disabledGoogleAutocomplete &&
              !this.donation.isSameAddress
            ) {
              this.errors.add({
                field: "gift-map",
                msg: "Address required"
              });
              hasErrors = true;
            }

            if (hasErrors) {
              return reject("Address not entered");
            }

            const hasPayementHasChanged =
              this.payementType != this.donation.payementType;

            if (hasPayementHasChanged) {
              this.donation.payementType = this.payementType;
            }

            this.$store
              .dispatch("saveDonationStep2")
              .then(response => {
                // push datalayer checkout
                gtm.pushCheckout(
                  this.product.productname,
                  this.product.id,
                  this.donation.amount,
                  this.product.producttype,
                  getNameByDonationType(this.donation.type)
                );

                if (this.donation.payementType == "wwf_paypal") {
                  this.$store
                    .dispatch("checkoutPaypal")
                    .then(response => {
                      window.location.href = response;
                    })
                    .catch(error => {
                      console.error("checkout step 2", error);
                      reject(error);
                    });
                } else if (!this.useNewCheckout && hasPayementHasChanged) {
                  // OLD BAMBORA CHECKOUT
                  this.$store
                    .dispatch("checkout")
                    .then(response => {
                      if (response.body.method == "redirect") {
                        window.location.href = response.body.url;
                      } else {
                        resolve();
                      }
                    })
                    .catch(error => {
                      console.error("checkout step 2", error);
                      reject(error);
                    });
                } else {
                  resolve();
                }
              })
              .catch(error => {
                console.error("saveDonation2 error", error);
                reject(error);
              });
          }
        });
      });
    }
  }
};
</script>

<style scoped>
.wwf-alert-address {
  color: var(--errorColor);
}

.wwf-alert-address a {
  color: var(--primaryColor);
}

.unit-no-alert {
  height: 45px;
  background: var(--wwfGreen);
  border-radius: 5px;
  position: relative;
}

.unit-no-alert-container {
  height: 60px;
}

.unit-no-alert p {
  color: var(--wwfWhite);
  line-height: normal;
  font-size: 14px;
  font-weight: 600;
  padding: 5px;
}

.unit-no-alert:before {
  content: "";
  width: 20px;
  height: 20px;
  left: -4px;
  top: 50%;
  background: inherit;
  position: absolute;
  transform: rotate(45deg) translateY(-50%);
  border-radius: 4px;
  transform-origin: top;
}

.unit-no-border input[type="tel"],
.unit-no-border input[type="tel"]:hover {
  box-shadow: inset 0 0 0 3px var(--wwfGreen);
}

.unit-no-alert.fadeaway {
  opacity: 0;
}

/* PAYMENT TYPE */

.payment-type ul.wwf-radio-bttns.payment-type--radio {
  margin: 0;
  list-style-type: none;
  font-size: 0;
  display: block;
  flex-direction: row;
  flex-wrap: wrap;
}

.payment-type .wwf-radio-bttns label img.paymentType {
  width: 30px;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.15);
  border-radius: 2px;
  margin-top: -1px;
  vertical-align: middle;
  text-align: right;
  display: inline-block;
}

.payment-type .wwf-radio-bttns.payment-type--radio li {
  display: block;
  border-radius: 3px;
  margin-bottom: 10px;
}

.payment-type .wwf-radio-bttns label img.paymentType.paymentType--PayPal {
  width: 65px;
  box-shadow: none;
  margin-left: 5px;
}

.payment-type .wwf-radio-bttns label img.paymentType:first-child {
  margin-left: 10px;
}

.payment-type .wwf-radio-bttns label img.paymentType.paymentType--amex {
  box-shadow: none;
}

.payment-type .wwf-radio-bttns label img.paymentType.paymentType--visa {
  margin-left: 5px;
}

@media only screen and (max-width: 64em) {
  ul.wwf-radio-bttns.payment-type--radio {
    display: block;
  }

  ul.wwf-radio-bttns.payment-type--radio li {
    flex-basis: 100%;
  }

  ul.wwf-radio-bttns.payment-type--radio li:nth-child(2) {
    width: 100%;
  }
}

.title-required {
  color: var(--errorColor);
  margin-top: 10px;
}

.title-required-gift {
  text-align: left;
  width: 120px;
  display: inline-block;
}

.bequest-checkbox {
  margin-top: 20px;
}
</style>


// WEBPACK FOOTER //
// Step2.vue?0d4bca54